<template>
  <div class="app-form">
    <el-form
      ref="formFconttitre"
      :model="form"
      label-width="100px"
      label-position="right"
      :rules="rules"
      :validate-on-rule-change="false"
    >
      <!-- CHAMPS -->
      <!-- Type -->
      <el-form-item label="Type" prop="id_fcont_cat">
        <el-select
          v-model="form.id_fcont_cat"
          clearable
          filterable
          placeholder="Choisissez un type de formation continue"
          :disabled="catdesactive"
        >
          <el-option
            v-for="item in catOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- Titre -->
      <el-form-item label="Titre" prop="titre">
        <el-input v-model="form.titre" style="width: 300px"> </el-input>
      </el-form-item>
      <!-- Date maj -->
      <p class="updated-at" v-show="form.updated_at">
        Dernière maj :
        {{ form.updated_at }}
      </p>
      <!-- -->
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      rules: {
        id_fcont_cat: [
          {
            required: true,
            message: "Ce champ est obligatoire",
            trigger: "change",
          },
        ],
        titre: [
          {
            required: true,
            message: "Ce champ est obligatoire",
            trigger: "blur",
          },
        ],
      },
    };
  },
  props: {
    catdesactive: Boolean,
  },
  computed: {
    form: {
      // https://vuex.vuejs.org/guide/forms.html#two-way-computed-property
      get() {
        return this.$store.state.fctit.titre;
      },
      set(form) {
        this.$store.commit("fctit/setTitre", form);
      },
    },
    catOptions() {
      return this.$store.getters["fccat/categorieSelect"];
    },
  },
};
</script>
